/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Legal_EntityInputs */

const cs_settings_venues_legal_entity = /** @type {(inputs: Settings_Venues_Legal_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Právnická osoba`)
};

const en_settings_venues_legal_entity = /** @type {(inputs: Settings_Venues_Legal_EntityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal entity`)
};

/**
* | output |
* | --- |
* | "Legal entity" |
*
* @param {Settings_Venues_Legal_EntityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_legal_entity = /** @type {((inputs?: Settings_Venues_Legal_EntityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Legal_EntityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_legal_entity(inputs)
	return cs_settings_venues_legal_entity(inputs)
});